import { sessionApis } from "apis/sessionAPI";
import { useGlobalConfig } from "context/GlobalContext";
import { useRequestApiData } from "hooks";
import { RootLayout } from "layouts/RootLayout";
import React, { Suspense } from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { GetConfigsAPI } from "types/common/configs/baseConfigs";

const App = () => {

  const { rc } = useGlobalConfig();
  const params = {
    pilotId : rc.session.getPilotId()
  }
  const { data } = useRequestApiData<GetConfigsAPI.retval>(
    sessionApis.fetchConfigsStrings,
    rc,
    params,
    []
  );

  const translations = data?.stringResources;
  const configs = data?.frontendConfigs;
  const theme = data?.colorPaletteTheme;

  rc.translations.setTranslations(translations);
  rc.config.setConfigData(configs);
  rc.theme.setTheme(theme);
  return (
    data ? (
    <RootLayout>
      <Suspense
        fallback={
         <></>
        }
      >
        <Outlet />
      </Suspense>
    </RootLayout>
    ) :
    <></>
    
  );
};

export interface RouteGuardProps {
  children : React.ReactNode
}

export const RouteGuard = () => {

  const { rc } = useGlobalConfig();
  const isLoggedIn =  useSelector((state : any) => state.session.isLoggedIn);
  
  const userLoggedInCache = rc.session.isUserLoggedIn();

  const location = useLocation()

  return isLoggedIn || userLoggedInCache ? 
    <App/> : <Navigate to="/auth" replace state={{ path : location.pathname}} />
}